const REDIRECT_PARAM = "redirect_url";
const AUTH_PATHS = ["/signin", "/forgotpassword"];

const isAuthPath = (path: string) =>
  AUTH_PATHS.some((p) => path === p || path.startsWith(`${p}/`) || path.startsWith(`${p}?`));

// Only same-origin relative paths are allowed, to avoid open redirects.
const isSafeRedirectPath = (path: string | null): path is string =>
  !!path &&
  path.startsWith("/") &&
  !/[\t\n\r]/.test(path) &&
  !path.startsWith("//") &&
  !path.startsWith("/\\") &&
  !isAuthPath(path);

export const buildSigninUrl = (
  location: Pick<Location, "pathname" | "search" | "hash"> = window.location
): string => {
  const target = `${location.pathname}${location.search}${location.hash}`;
  if (target === "/" || !isSafeRedirectPath(target)) {
    return "/signin";
  }
  return `/signin?${REDIRECT_PARAM}=${encodeURIComponent(target)}`;
};

export const getPostLoginPath = (search: string = window.location.search): string => {
  const target = new URLSearchParams(search).get(REDIRECT_PARAM);
  return isSafeRedirectPath(target) ? target : "/";
};
